import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const adminToken = localStorage.getItem("em_admin_token");
  const siteToken = localStorage.getItem("em_site_token");
  const url = (cfg.url || "").toString();
  const isAdminRoute = url.startsWith("/admin") || url.includes("/admin/");
  // For /admin/* routes we must use the admin token.
  // For other routes, prefer the site token but fall back to admin token
  // (admin scope is a superset and grants access to site endpoints too).
  if (isAdminRoute) {
    if (adminToken) cfg.headers.Authorization = `Bearer ${adminToken}`;
  } else if (siteToken) {
    cfg.headers.Authorization = `Bearer ${siteToken}`;
  } else if (adminToken) {
    cfg.headers.Authorization = `Bearer ${adminToken}`;
  }
  return cfg;
});

export default api;
